(function(){
  'use strict';
  var T=window.ABT||{},root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var COL='all-items-ex-ship';
  var eligible=null;
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
  function ssc(){return window.SectionStoreCart||null}
  function money(c){var s=ssc();return s&&s.formatMoney?s.formatMoney(Math.round(c)):'€'+(c/100).toFixed(2)}
  function loadEligible(){
    if(eligible)return Promise.resolve(eligible);
    try{var c=sessionStorage.getItem('ab_b2g1_ids');if(c){eligible={};JSON.parse(c).forEach(function(i){eligible[i]=1});return Promise.resolve(eligible)}}catch(e){}
    return fetch(root+'collections/'+COL+'/products.json?limit=250').then(function(r){return r.json()}).then(function(j){
      var ids=j.products.map(function(p){return p.id});eligible={};ids.forEach(function(i){eligible[i]=1});
      try{sessionStorage.setItem('ab_b2g1_ids',JSON.stringify(ids))}catch(e){}
      return eligible;
    }).catch(function(){eligible={};return eligible});
  }
  function isGift(i){return ABG.isGift(i)}
  function readCart(){return fetch(root+'cart.js',{cache:'no-store',credentials:'same-origin'}).then(function(r){return r.json()})}
  var cmp={};
  function compareAt(i){
    if(cmp[i.variant_id]!==undefined)return Promise.resolve(cmp[i.variant_id]);
    return fetch(root+'products/'+i.handle+'.js').then(function(r){return r.json()}).then(function(p){
      (p.variants||[]).forEach(function(v){cmp[v.id]=v.compare_at_price>v.price?v.compare_at_price:0});
      return cmp[i.variant_id]||0;
    }).catch(function(){cmp[i.variant_id]=0;return 0});
  }
  // Same sum as the cart drawer: (original price or price) minus what Shopify charges. Free gifts do not count.
  function saved(cart){
    return Promise.all(cart.items.map(function(i){return isGift(i)?Promise.resolve(i.final_line_price):compareAt(i).then(function(c){return (c||i.price)*i.quantity})})).then(function(v){
      return Math.max(0,v.reduce(function(a,b){return a+b},0)-cart.total_price);
    });
  }
  var VS={nl:' t.o.v. de originele prijs',de:' gegenüber dem Originalpreis',fr:" par rapport au prix d'origine",en:' vs. the original price'};
  function state(cart){
    var imgs=[],units=0;
    cart.items.forEach(function(i){
      if(!eligible[i.product_id]||isGift(i))return;
      for(var n=0;n<i.quantity;n++){units++;imgs.push(i.image)}
    });
    return {units:units,imgs:imgs};
  }
  function paint(cart,my){
    var s=state(cart),o=ABG.offer(s.units,ABG.free(cart)),rem=s.units%3,done=o.kind==='done';
    ABG.last={units:s.units,kind:o.kind,m:ABG.model(cart,eligible)};
    document.dispatchEvent(new CustomEvent('ab:b2g1',{detail:ABG.last}));
    var show=done?s.imgs.slice(-3):s.imgs.slice(s.units-rem);
    var txt=s.units===0?T.empty:ABG.text(o);
    $$('[data-ab-tracker]').forEach(function(el){
      el.classList.toggle('is-done',done);
      el.querySelector('[data-t]').textContent=txt;
      $$('[data-s]',el).forEach(function(b,i){var u=show[i];b.style.backgroundImage=u?'url("'+u+'")':'';b.textContent=(!u&&i===2)?T.free:''});
    });
    $$('[data-ab-mini]').forEach(function(m){m.hidden=s.units===0||o.kind!=='add';var t=m.querySelector('[data-t]');if(t)t.textContent=txt});
    var tr=$$('[data-ab-tracker] [data-m]');if(!tr.length)return;
    if(!cart.items.length){tr.forEach(function(m){m.textContent=''});return}
    saved(cart).then(function(a){
      if(my!==seq)return;
      var l=((window.Shopify&&Shopify.locale)||'en').slice(0,2),t=a>0?T.save.replace('{a}',money(a))+(VS[l]||VS.en):'';
      tr.forEach(function(m){m.textContent=t});
    });
  }
  var seq=0;
  function refresh(){var my=++seq;readCart().then(function(c){if(my===seq)paint(c,my)}).catch(function(){})}
  function klaviyo(){
    if(window.item!==undefined||!window._learnq)return;
    readCart().then(function(d){window._learnq.push(['track','Added to Cart',{total_price:d.total_price/100,$value:d.total_price/100,total_discount:d.total_discount,original_total_price:d.original_total_price/100,items:d.items}])}).catch(function(){});
  }
  function add(items,btn){
    var s=ssc();if(!s)return Promise.resolve();
    if(btn){btn.disabled=true}
    var p=items.length===1?s.addItem(items[0]):s.addItems(items);
    return Promise.resolve(p).then(function(){if(s.open)s.open();refresh();klaviyo()}).finally(function(){if(btn)btn.disabled=false});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-ab-add]');
    if(a){e.preventDefault();add([{id:+a.getAttribute('data-ab-add'),quantity:1}],a);var q=a.closest('[data-ab-card]');if(q)q.classList.remove('is-qa');return}
    var q2=e.target.closest('[data-ab-qa]');
    if(q2){e.preventDefault();var c=q2.closest('[data-ab-card]'),on=!c.classList.contains('is-qa');$$('.is-qa').forEach(function(x){x.classList.remove('is-qa')});c.classList.toggle('is-qa',on);q2.setAttribute('aria-expanded',on);return}
    var l=e.target.closest('[data-ab-addlook]');
    if(l){var box=l.closest('[data-ab-look]'),sel=$$('[data-ab-size]',box),miss=sel.filter(function(x){x.classList.remove('err');return !x.value});
      if(miss.length){miss.forEach(function(x){x.classList.add('err')});miss[0].focus();return}
      add(sel.map(function(x){return {id:+x.value,quantity:1}}),l);return}
    if(!e.target.closest('.abx-qa__s'))$$('.is-qa').forEach(function(x){x.classList.remove('is-qa')});
  });
  // Koala's popup records a claimed gift, but in some browsers never puts it in the cart. When a click records a claim and
  // the gift is still missing shortly after, add it with Koala's own line property: Koala's discount then makes it free and
  // Koala still removes it when the cart drops below the threshold.
  var KG='KG_POPUP_OFFERS';
  function kgRead(){try{return localStorage.getItem(KG)||''}catch(e){return ''}}
  function kgGifts(v){
    var out=[];
    try{var o=JSON.parse(v||'{}');Object.keys(o).forEach(function(k){(o[k]||[]).forEach(function(i){if(i&&i.id&&i.properties&&i.properties.__koala_gift)out.push({id:i.id,quantity:1,properties:i.properties})})})}catch(e){}
    return out;
  }
  document.addEventListener('click',function(){
    var before=kgRead();
    setTimeout(function(){
      var after=kgRead();
      if(after===before)return;
      var gifts=kgGifts(after),s=ssc();
      if(!gifts.length||!s)return;
      setTimeout(function(){
        readCart().then(function(c){
          if(c.items.some(function(i){return i.properties&&i.properties.__koala_gift}))return;
          return Promise.resolve(gifts.length===1?s.addItem(gifts[0]):s.addItems(gifts)).then(refresh);
        }).catch(function(){});
      },2000);
    },600);
  },true);
  function trust(){
    var els=$$('[data-ab-tp]');if(!els.length)return;
    function put(d){els.forEach(function(e){var k=e.getAttribute('data-ab-tp');if(d[k]!=null)e.textContent=d[k]})}
    var c=null;try{c=JSON.parse(sessionStorage.getItem('ab_tp')||'null')}catch(e){}
    if(c&&(c.score||c.count))put(c);
  }
  function start(){
    trust();
    if(!$$('[data-ab-tracker],[data-ab-mini],[data-ab-bundle]').length)return;
    loadEligible().then(function(){
      refresh();
      var tries=0;(function w(){var s=ssc();if(s&&s.subscribe){s.subscribe(refresh)}else if(++tries<100){setTimeout(w,200)}})();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  window.ABX={refresh:refresh,add:add};
})();
